import React, { useEffect, useState } from "react";
import {
  deleteUser,
  fetchUserList,
  updateUser,
} from "../../services/userService";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import { brandColors } from "../../App";
import EditIcon from "@mui/icons-material/Edit";
import { apiRequest } from "../../utils/apiClient";

const Users: React.FC = () => {
  const [users, setUsers] = useState([]);
  const [Search, setSearch] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedPwd, setSelectedPwd] = useState<any>();
  const [selectedUser, setSelectedUser] = useState<any>();
  const [stores, setStores] = useState<any[]>();
  const [roles, setRoles] = useState<any[]>();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const user = useSelector((state: RootState) => state.auth.user);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70vw",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const handleSubmit = async () => {
    try {
      if (!selectedPwd?.pwd) {
        const data = await updateUser({
          ...selectedUser,
          discount_percent: selectedUser.discount_percent,
        });

        if (data.user_id) {
          setUsers((prev: any) =>
            prev.map((user: any) =>
              user.user_id === data.user_id ? data : user,
            ),
          );

          alert("User updated successfully");
          handleClose();
          setSelectedPwd(null);
          setSelectedUser(null);
        } else {
          alert("Error updating user");
        }

        return; // important to stop execution
      }

      if (selectedPwd?.pwd !== selectedPwd?.confirmPwd) {
        alert("Password and confirm password do not match");
        return;
      }

      const data = await updateUser({
        ...selectedUser,
        password: selectedPwd.pwd,
        discount_percent: selectedUser.discount_percent,
      });

      if (data.user_id) {
        setUsers((prev: any) =>
          prev.map((user: any) =>
            user.user_id === data.user_id ? data : user,
          ),
        );

        alert("User updated successfully");
        handleClose();
        setSelectedPwd(null);
        setSelectedUser(null);
      } else {
        alert("Error updating user");
      }
    } catch (error) {
      console.error("Error updating user:", error);
    } finally {
      setLoading(false);
    }
  };
  const getUserData = async () => {
    try {
      const data = await fetchUserList(Search); // Fetch the inventory data from an API
      if (user?.role === "SuperAdmin") {
        setUsers(data);
      } else {
        setUsers(data.filter((user: any) => user.role_name !== "SuperAdmin"));
      }
    } catch (error) {
      console.error("Error fetching inventory:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getUserData();
  }, []);
  const handleEdit = (user: any) => {
    setSelectedUser(user);
    handleOpen();
  };
  const getAllStores = async () => {
    try {
      const response = await apiRequest("/api/stores/list", "POST");
      if (response.data.length > 0) {
        setStores(response.data);
      }
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
  };
  const getAllRoles = async () => {
    try {
      const response = await apiRequest("/api/roles/list", "POST");
      if (response.data.rows.length > 0) {
        if (user?.role === "SuperAdmin") {
          setRoles(response.data.rows);
        } else {
          setRoles(
            response.data.rows.filter(
              (role: any) => role.name !== "SuperAdmin",
            ),
          );
        }
      }
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
  };
  useEffect(() => {
    getAllStores();
    getAllRoles();
  }, []);
  const handleDelete = async (user: any) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this user?",
    );
    try {
      if (!confirmation) {
        return;
      }
      const data = await deleteUser(user.user_id); // Fetch the inventory data from an API
      if (data.user_id) {
        getUserData();
        alert("User deleted successfully");
      }
    } catch (error) {
      console.error("Error fetching inventory:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box sx={{ padding: 1 }}>
        {loading ? (
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
        ) : (
          <>
            <TableContainer component={Paper} sx={{ height: "80vh" }}>
              <Table size="small">
                <TableHead>
                  <TableRow
                    sx={{ backgroundColor: brandColors.header, color: "white" }}
                  >
                    <TableCell sx={{ color: "white" }}>Username</TableCell>
                    <TableCell sx={{ color: "white" }}>Email</TableCell>
                    <TableCell sx={{ color: "white" }}>Role</TableCell>
                    <TableCell sx={{ color: "white" }}>Store</TableCell>
                    <TableCell sx={{ color: "white" }}>
                      Discount Percent
                    </TableCell>
                    <TableCell sx={{ color: "white" }}>Edit</TableCell>
                    <TableCell sx={{ color: "white" }}>Delete</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users &&
                    users.map((prod: any) => (
                      <TableRow key={prod.product_id}>
                        <TableCell>{prod.username}</TableCell>
                        <TableCell>{prod.email}</TableCell>
                        <TableCell>{prod.role_name}</TableCell>
                        <TableCell>{prod.store_name}</TableCell>
                        <TableCell>{prod.discount_percent}</TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            onClick={() => handleEdit(prod)}
                          >
                            <EditIcon />
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleDelete(prod)}
                            disabled={user?.role !== "SuperAdmin"}
                          >
                            <DeleteIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                {/* <Typography id="modal-modal-title" variant="h6" component="h2">
                  Change Password
                </Typography> */}
                <Grid container spacing={2} justifyContent="center">
                  <Grid size={12}>
                    <Typography
                      id="modal-modal-title"
                      component="h2"
                      sx={{
                        color: brandColors.header,
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      {selectedUser && selectedUser.email}
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Select
                      value={selectedUser?.role_id}
                      sx={{ width: "100%" }}
                      label="Role"
                      name="Role"
                      onChange={(e) =>
                        setSelectedUser((prev: any) => ({
                          ...prev,
                          role_id: e.target.value,
                        }))
                      }
                    >
                      {roles?.map((role) => (
                        <MenuItem key={role.role_id} value={role.role_id}>
                          {role.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Select
                      value={selectedUser?.store_id}
                      sx={{ width: "100%" }}
                      label="Store"
                      name="Store"
                      onChange={(e) =>
                        setSelectedUser((prev: any) => ({
                          ...prev,
                          store_id: e.target.value,
                        }))
                      }
                    >
                      {stores?.map((store) => (
                        <MenuItem key={store.store_id} value={store.store_id}>
                          {store.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid size={{ xs: 6, md: 6 }}>
                    <TextField
                      id="outlined-basic"
                      label="Password"
                      variant="outlined"
                      type="password"
                      sx={{ width: "100%" }}
                      onChange={(e) =>
                        setSelectedPwd({ ...selectedPwd, pwd: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid size={{ xs: 6, md: 6 }}>
                    <TextField
                      id="outlined-basic"
                      label="Confirm Password"
                      variant="outlined"
                      type="password"
                      sx={{ width: "100%" }}
                      onChange={(e) =>
                        setSelectedPwd({
                          ...selectedPwd,
                          confirmPwd: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                      id="outlined-basic"
                      label="Discount Percent"
                      variant="outlined"
                      type="number"
                      sx={{ width: "100%" }}
                      value={selectedUser?.discount_percent}
                      onChange={(e) =>
                        setSelectedUser({
                          ...selectedUser,
                          discount_percent: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                  <Grid
                    size={12}
                    sx={{ display: "flex", justifyContent: "center", gap: 3 }}
                  >
                    <Button variant="contained" onClick={handleSubmit}>
                      Submit
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Modal>
          </>
        )}
      </Box>
    </>
  );
};

export default Users;
